import React, { useState } from "react"
import PropTypes from "prop-types"
import Card from "../../../components/atoms/Card.atom"

const ClientReportCard = ({
  icon,
  iconClassName,
  title,
  headerButton = null,
  className,
  children,
  collapsible = false,
  defaultCollapsed = false,
}) => {
  const DEFAULT_SHADOW = "shadow-2"
  const [collapsed, setCollapsed] = useState(defaultCollapsed)

  return (
    <Card
      className={`client-report-card card--with-title-icon ${DEFAULT_SHADOW} ${className}`}
    >
      <div className="flex flex-column gap-4 w-full">
        <div className="header flex gap-2 align-items-center justify-content-between">
          <div className="flex gap-2 align-items-center title">
            {iconClassName ?
              <i className={`${iconClassName} clr-primary-highlight`} />
            : icon}

            <span
              style={{ fontSize: "min(3.25vw, 18px)", lineHeight: "1" }}
              className="font-semibold"
            >
              {title}
            </span>
          </div>

          <div className="flex align-items-center gap-2">
            {headerButton}

            {collapsible && (
              <button
                type="button"
                className="client-report-collapse-btn p-link border-none bg-transparent cursor-pointer"
                onClick={() => setCollapsed((prev) => !prev)}
              >
                <i
                  className={`pi ${
                    collapsed ? "pi-chevron-down" : "pi-chevron-up"
                  } `}
                />
              </button>
            )}
          </div>
        </div>

        {!collapsed && children}
      </div>
    </Card>
  )
}

export default ClientReportCard

ClientReportCard.propTypes = {
  icon: PropTypes.node,
  iconClassName: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  headerButton: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  collapsible: PropTypes.bool,
  defaultCollapsed: PropTypes.bool,
}
